<template>
	<PageLoading :is-loading="isLoading"></PageLoading>
	<SideComponent @scrollto="scroll"></SideComponent>
	<div class="container" ref="viewBox">		
		<div class="header-container">
			<HeaderVR />
			<!-- <div class="bigimg-container" v-if="banner.length>0">
				<Swiper :list="banner"/>
			</div> -->
		</div>
		<div id="content" class="content" ref="content">
			<Loading :is-loading="isListLoading"></Loading>			
			<section class="section">
				<div class="ar-content">
					<div style="font-family: 黑体, SimHei; font-size: 24px;font-weight:bold;">{{taleDetail.title}}</div>
					<div style="font-family: 黑体, SimHei; font-size: 14px;color:#9b9b9b;margin:12px 0;">{{taleDetail.created_at}}</div>
					<div class="html-content" style="margin-top: 20px;" id="html-content" v-html="taleDetail.content"></div>					
				</div>
			</section>
		</div>		
		<Footer/>
	</div>
	
</template>

<script>
	import publish_detail from './publish_detail_controller';
	export default publish_detail;
</script>

<style src="@/assets/css/publish_detail.css" scoped></style>
<!-- 这段全局css代码在related_news_detail.vue,subject_detail.vue,tail_detail.vue都有，而且相同。 -->
<style>
/*.ar-content .html-content p img{
	width:86%!important;
	max-width:800px;
	height:auto!important;
	object-fit: contain;
}
@media screen and (max-width: 767px) {
	.ar-content .html-content p img{
		width:100%!important;
		max-width:375px!important;
		height:auto!important;
	}
}*/
</style>

